import dayjs from "dayjs";

export const normalizeTournamentId = (value) => (value == null ? null : String(value));

export const getTournamentId = (tournament) =>
  normalizeTournamentId(tournament?.id ?? tournament?.uuid ?? tournament?.data?.id ?? tournament?.data?.uuid);

export const getEventTournamentId = (eventLike) => {
  const match = eventLike?.extendedProps?.match ?? eventLike?.match;

  return getTournamentId(match?.data?.tournament?.data);
};

const readOnlyEvent = {
  editable: false,
  startEditable: false,
  durationEditable: false,
  resourceEditable: false,
};

const isBooking = (event) => event.event_kind === "booking";

const occursOnDate = (event, dateKey) => {
  const start = dayjs(event.start);
  const end = dayjs(event.end || event.start);
  const dayStart = dayjs(`${dateKey}T00:00:00`);
  const dayEnd = dayStart.add(1, "day");

  return start.isValid() && end.isValid() && start.isBefore(dayEnd) && end.isAfter(dayStart);
};

export function filterCompetitionCalendarEvents(events, viewType, dateKey, showOccupancy = false) {
  if (!showOccupancy || viewType !== "resourceTimeGridDay" || !dateKey) {
    return events.filter((event) => !isBooking(event));
  }

  const dayEvents = events.filter((event) => occursOnDate(event, dateKey));
  const hasTournamentMatches = dayEvents.some((event) => !isBooking(event));

  return hasTournamentMatches ? dayEvents : dayEvents.filter((event) => !isBooking(event));
}

export function buildCompetitionCalendarEvents({
  events,
  tournaments,
  tournamentColors,
  bookingColors,
  matchTextColor,
}) {
  return events.map((event) => {
    if (event.event_kind === "booking") {
      return {
        ...event,
        ...bookingColors,
        classNames: [...(event.classNames || []), "scheduling-occupancy", "scheduling-booking"],
        ...readOnlyEvent,
      };
    }

    const tournamentId = getEventTournamentId(event);
    const tournamentIndex = tournaments.findIndex((tournament) => getTournamentId(tournament) === tournamentId);
    const tournamentColor = tournamentIndex >= 0 ? tournamentColors[tournamentIndex % tournamentColors.length] : null;

    return {
      ...event,
      ...(tournamentColor
        ? {
            backgroundColor: tournamentColor,
            borderColor: tournamentColor,
            textColor: matchTextColor,
          }
        : {}),
      ...readOnlyEvent,
    };
  });
}
